import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Inget resultat")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, _mergeProps({ loading: _ctx.loading }, _ctx.$props, {
    square: "",
    outlined: _ctx.outlined,
    modelValue: _ctx.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
    "use-input": "",
    "input-debounce": "0",
    multiple: _ctx.multiple,
    label: _ctx.label,
    options: _ctx.filteredOptions,
    onFilter: _ctx.filterFn,
    rules: _ctx.rules,
    readonly: _ctx.readonly,
    disable: _ctx.disable,
    "fill-input": "",
    "hide-selected": _ctx.hideSelect,
    clearable: "",
    "transition-show": "jump-up",
    "transition-hide": "jump-up"
  }), {
    "no-option": _withCtx(() => [
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "text-grey" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16, ["loading", "outlined", "modelValue", "multiple", "label", "options", "onFilter", "rules", "readonly", "disable", "hide-selected"]))
}